<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
		<g :class="[active ? 'active' : 'non-active']">
			<path d="M24.583 0H.417C.187 0 0 .199 0 .444v5.778C0 7.204.746 8 1.667 8H3.75c.48-.002.937-.226 1.25-.614.313.388.77.612 1.25.614h2.5c.48-.002.937-.226 1.25-.614.313.388.77.612 1.25.614h2.5c.48-.002.937-.226 1.25-.614.313.388.77.612 1.25.614h2.5c.48-.002.937-.226 1.25-.614.313.388.77.612 1.25.614h2.083C24.253 8 25 7.204 25 6.222V.444C25 .2 24.813 0 24.583 0zm-20 6.222c0 .491-.373.89-.833.89H1.667c-.46 0-.834-.399-.834-.89V.89h3.75v5.333zm5 0c0 .491-.373.89-.833.89h-2.5c-.46 0-.833-.399-.833-.89V.89h4.166v5.333zm5 0c0 .491-.373.89-.833.89h-2.5c-.46 0-.833-.399-.833-.89V.89h4.166v5.333zm5 0c0 .491-.373.89-.833.89h-2.5c-.46 0-.833-.399-.833-.89V.89h4.166v5.333zm4.584 0c0 .491-.373.89-.834.89H21.25c-.46 0-.833-.399-.833-.89V.89h3.75v5.333zM17.577 15H7.423a.416.416 0 0 0-.423.41v1.635c0 .226.19.41.423.41h4.654v1.16l-.468 1.357a6.088 6.088 0 0 1-2.711 3.268.402.402 0 0 0-.145.562.426.426 0 0 0 .362.198h6.77a.416.416 0 0 0 .423-.41.406.406 0 0 0-.206-.35 6.085 6.085 0 0 1-2.714-3.27l-.465-1.354v-1.161h4.654a.416.416 0 0 0 .423-.41V15.41c0-.226-.19-.409-.423-.409zm-2.979 8.182h-4.196a6.853 6.853 0 0 0 2.01-2.95l.088-.256.088.254a6.847 6.847 0 0 0 2.01 2.952zm2.556-6.546H7.846v-.818h9.308v.818z"/>
			<path d="M9 19.573H4.073L2.846 15 2 15.234l1.315 4.902a.44.44 0 0 0 .423.328h1.228l-.783 4.376.863.16.812-4.536H6.88L7.692 25l.863-.16-.783-4.376H9v-.89zM21.154 15l-1.227 4.573H15v.891h1.228l-.783 4.376.862.16.813-4.536h1.022L18.953 25l.863-.16-.782-4.376h1.228a.44.44 0 0 0 .423-.328L22 15.234 21.154 15zM22.563 8H2.438C2.196 8 2 8.16 2 8.357V13h.875V8.714h19.25V13H23V8.357C23 8.16 22.804 8 22.562 8zM.857 24.17V8H0v16.585c0 .23.192.415.429.415H3v-.83H.857zM24.143 8v16.15H22V25h2.571c.237 0 .429-.19.429-.425V8h-.857z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'coffee-shop-svg',
	props: {
		active: {
			default: false,
			type: Boolean,
		},
	},
};
</script>
<style lang="scss" scoped>
	.active {
		fill: white;
	}

	.non-active {
		fill: color(secondary);
	}

</style>



// WEBPACK FOOTER //
// src/components/shared/icons/coffee-shop.vue